import React from "react";
import { Outlet, useLocation } from 'react-router-dom';
import "../../App.scss";
import "../../index.css"
import Headers from "./Header";
import { ConfigProvider, Layout } from 'antd';
import Footers from "./Footer";
import { frontendurls } from "../../constants/FrontendURLs";
import ScrollToTop from "./scrollToTop/ScrollToTop";

const Layouts = () => {
	const location = useLocation();
	const excludedRoutes = [frontendurls.AdminDashboard, frontendurls.Home, frontendurls.Profile, "/"];
	const isExcludedRoute = excludedRoutes.includes(location.pathname);

	return (
		<ConfigProvider
			theme={{
				token: {
					colorPrimary: "#eb8a14",
					colorInfo: "#eb8a14"
				},
				components: {
					Switch: {
						colorPrimary: "rgb(152,0,46)",
						colorPrimaryHover: "#98003d",
						colorPrimaryBorder: "rgba(152,0,46,0.73)",
						colorTextQuaternary: "rgba(0,0,0,0.45)",
						colorTextTertiary: "rgba(0,0,0,0.65)",
						handleSize: 26,
						fontSize: 20,
					},
					Spin: {
						colorPrimary: "rgb(107,1,33)",
					},
					Collapse: {
						headerBg: "rgb(107,1,33)",
						colorTextHeading: "rgba(255,255,255,0.88)"
					}
				},
			}}
		>
			<Layout>
				<Headers />
				<div className={`min-h-[calc(100vh-143.35px)] ${isExcludedRoute ? "" : "bg-white"}`}>
					<ScrollToTop />
					<Outlet />
				</div>
				<Footers />
			</Layout>
		</ConfigProvider>
	);
};
export default Layouts;
